import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  editNotificationSuccess,
  editNotificationFailed,
  EDIT_NOTIFICATION_START,
} from '~/views/app/redux/actions/notification'

/**
 * edit notifcation api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const editNotificationApi = (props) => {
  const uri = `/notifications/${props?.id}`
  return api.patch(uri, props?.data)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doEditNotification(action) {
  try {
    const response = yield call(editNotificationApi, action?.payload)

    if (response?.statusCode !== 400) {
      yield put(editNotificationSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      } else {
        throw response?.message
      }
    }
  } catch (error) {
    yield put(editNotificationFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch edit notifcation
 */
export default function* watchEditNotification() {
  yield takeLatest(EDIT_NOTIFICATION_START, doEditNotification)
}
